// removed by extract-text-webpack-plugin
module.exports = {"sociallinks":"src-components-SocialLinks----SocialLinks-module---sociallinks---3hmD3","share-count":"src-components-SocialLinks----SocialLinks-module---share-count---18DnY","SocialMediaShareButton":"src-components-SocialLinks----SocialLinks-module---SocialMediaShareButton---2le7L","bounce":"src-components-SocialLinks----SocialLinks-module---bounce---32nY3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialLinks/SocialLinks.module.scss
// module id = 435
// module chunks = 168707334958949